<template>
  <div>
    <div class="radio wrapper_item" v-if="!employee_key">
      <div
          class="radio-item"
          v-for="(item) in tabs"
          :class="{active: tab == item.key}"
          :key="item.key"
          @click="tab = item.key"
      >
        {{item.title}}
      </div>

    </div>
    <div cdivs="wrapper_item" v-if="!employee_key">
      <label class="wrapper_label">Название компании</label>
      <input name="company_name" autocomplete="off" v-model="company_name" class="wrapper_input" type="text" v-validate="'required'" v-on:focus="changeInput" data-vv-validate-on="blur">
      <span class="text-danger text-sm">{{ errors.first('company_name') }}</span>
      <div class="text-danger text-sm" v-if="error_company_name && !errors.first('company_name')">{{ error_company_name }}</div>
    </div>
    <div class="wrapper_item" v-if="!employee_key">
      <label class="wrapper_label">Фамилия</label>
      <input name="surname" autocomplete="off" v-model="surname" class="wrapper_input" type="text" v-validate="'required'" v-on:focus="changeInput" data-vv-validate-on="blur">
      <span class="text-danger text-sm">{{ errors.first('surname') }}</span>
      <div class="text-danger text-sm" v-if="error_surname && !errors.first('surname')">{{ error_surname }}</div>
    </div>
    <div class="wrapper_item" v-if="!employee_key">
      <label class="wrapper_label">Имя</label>
      <input name="name" autocomplete="off" v-model="name" class="wrapper_input" type="text" v-validate="'required'"  v-on:focus="changeInput" data-vv-validate-on="blur">
      <span class="text-danger text-sm">{{ errors.first('name') }}</span>
      <div class="text-danger text-sm" v-if="error_name && !errors.first('name')">{{ error_name }}</div>
    </div>
    <div class="wrapper_item" v-if="!employee_key">
      <label class="wrapper_label">E-mail</label>
      <input name="email" autocomplete="off" v-model="email" class="wrapper_input" type="text" v-validate="'required|email'" v-on:focus="changeInput" data-vv-validate-on="blur">
      <span class="text-danger text-sm">{{ errors.first('email') }}</span>
      <div class="text-danger text-sm" v-if="error_mail && !errors.first('email')">{{ error_mail }}</div>
    </div>
    <div class="wrapper_item">
      <label class="wrapper_label">Телефон</label>
      <input name="phone" autocomplete="off" id="phone-field" v-model="phone" class="wrapper_input" v-on:blur="phoneNumber" type="text" data-vv-validate-on="blur">
      <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
      <span class="text-danger text-sm" v-if="error_phone && !errors.first('phone')">{{ error_phone }}</span>
    </div>
    <div class="wrapper_item">
      <app-password v-model="password" ref="password" v-validate="'required|min:5|max:24|alpha_dash'" @blur="changeInput"  data-vv-validate-on="blur"/>
      <span class="text-danger text-sm">{{ errors.first('password') }}</span>
      <span class="text-danger text-sm" v-if="error_pass && !errors.first('password')">{{ error_pass }}</span>
    </div>
    <div class="wrapper_item">
      <app-password label="Повторите пароль" name="password_confirm" v-model="password_confirm" @blur="changeInput" v-validate="'required|confirmed:password'" data-vv-validate-on="blur" data-vv-as="Пароль"/>
      <span class="text-danger text-sm">{{ errors.first('password_confirm') }}</span>
      <span class="text-danger text-sm" v-if="error_pass && !errors.first('password_confirm')">{{ error_pass }}</span>
    </div>
    <button class="wrapper_button" @click="registration()" >Зарегистрироваться</button>
  </div>
</template>

<script>

import Inputmask from 'inputmask'
import AppPassword from "@/components/app-password";

export default {
    name: "registration",
  components: { AppPassword },
  data() {
        return {
          password: '',
          password_confirm: '',
          confirm_password: '',
          tabs: [
            { title: 'Закупщик', key: 2, },
            { title: 'Поставщик', key: 1, }
          ],
          tab: 2,
          company_name: '',
          surname: '',
          name: '',
          email: '',
          phone: '',
          key: '',
          employee_key: '',
          error_phone: null,
          error_pass: null,
          error_mail: null,
          error_name: null,
          error_surname: null,
          error_company_name: null,
        }
    },
    mounted() {
      const im = new Inputmask('+7(999) 999 99 99')
      im.mask(document.getElementById('phone-field'))
      if (this.$route.query.key) {
        this.key = this.$route.query.key;
      }
      if (this.$route.query.employee_key) {
        this.employee_key = this.$route.query.employee_key;
      }
    },
    computed: {
      validateForm () {
        if (!this.employee_key) {
          return !this.errors.any() &&
                  this.company_name !== '' &&
                  this.email !== '' &&
                  this.password !== '' &&
                  this.surname !== '' &&
                  this.phone !== '' &&
                  this.name !== ''
        } else {
          return !this.errors.any() &&
                  this.password !== '' &&
                  this.phone !== ''
        }

      }
    },
    methods: {
      phoneNumber(){
        this.error_phone = null;
        this.error_pass = null;

        if (this.phone.indexOf('_') !== -1) {
          this.error_phone = 'Поле телефон обязательно к заполнению.';
        }
      },
      changeInput(){
        this.error_pass = null;
        this.error_phone = null;
        this.error_mail = null;
        this.error_name = null;
        this.error_surname = null;
        this.error_company_name = null;
      },
      registration () {
        this.error_phone = null;
        this.error_mail = null;
        this.error_name = null;
        this.error_surname = null;
        this.error_company_name = null;
        let valid = false;
        if (!this.employee_key) {
          valid = this.phone && this.password && this.company_name && this.surname && this.name && this.email;
        }else{
          valid = this.phone && this.password;
        }

        if (valid){
          if (this.phone.indexOf('_') === -1) {
            this.validatePassword();
            if (!this.errors.any()) {
              this.$validator.validateAll().then(success => {
                if (success) {
                  this.$store.commit('setAuthLoading', true)
                  console.log('ssss',success)
                  this.$http.post(this.employee_key ? '/registration-from-invite' : '/registration', {
                    password: this.password,
                    type: this.tab,
                    company_name: this.company_name,
                    surname: this.surname,
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    key: this.key,
                    employee_key: this.employee_key
                  })
                      .then(({data}) => {
                        /*if (data.success) {
                          this.$toast.success('Вы успешно зарегистрированы! Ждите подтверждения');
                          this.$router.push({name: 'land'});
                        }*/
                        if (data.user) {
                          localStorage.setItem('token', data.user.token)
                          localStorage.setItem('type', data.user.type)
                          /*this.$router.push({name: 'main'})*/
                          location.href = '/' //для получения актуальной версии сайта
                        }
                      })
                      .catch((error) => {
                        if (error.response.data.errors) {
                          for (let key in error.response.data.errors) {
                            this.errors.add({
                              field: key,
                              msg: error.response.data.errors[key][0]
                            })
                          }
                        }
                      })
                      .finally(() => this.$store.commit('setAuthLoading', false))
                }
              })
            }
          } else {
            this.error_phone = this.phone.indexOf('_') !== -1 ? 'Поле телефон обязательно к заполнению.' : null;
          }
        }else{
          this.error_pass = !this.password ? 'Поле пароль обязательно к заполнению.'  : null;
          this.error_phone = !this.phone ? 'Поле телефон обязательно к заполнению.' : null;
          this.error_mail = !this.email ? 'Поле E-mail обязательно к заполнению.' : null;
          this.error_name = !this.name ? 'Поле имя обязательно к заполнению.' : null;
          this.error_surname = !this.surname ? 'Поле фамилия обязательно к заполнению.' : null;
          this.error_company_name = !this.company_name ? 'Поле название компании обязательно к заполнению.' : null;
        }
      },
      validatePassword () {
        var regexp = /[а-яё]/i;
        if(regexp.test(this.password)) {
          this.errors.add({
            field: 'password',
            msg: 'Поле пароль не должно содержать кириллицу'
          })
        }
        // const name = this.name.toLowerCase()
        // if (!this.employee_key) {
        //   if (this.password.indexOf(this.name) !== -1 || this.password.indexOf(name) !== -1) {
        //     this.errors.add({
        //       field: 'password',
        //       msg: 'Поле пароль не должно содержать имя'
        //     })
        //   }
        //
        //   const email = this.email.split('@')
        //   if (this.password.indexOf(email[0]) !== -1 || this.password.indexOf(email[0].toLowerCase()) !== -1) {
        //     this.errors.add({
        //       field: 'password',
        //       msg: 'Поле пароль не должно содержать email'
        //     })
        //   }
        // }
        //
        // const chars = this.password.match(/[A-Za-z]/g)
        // if (!chars || chars.length < 1) {
        //   this.errors.add({
        //     field: 'password',
        //     msg: 'Поле пароль должно содержать минимум 1 символа латинского алфавита'
        //   })
        // }
        //
        // const numbers = this.password.match(/[0-9]/g)
        // if (!numbers || numbers.length < 1) {
        //   this.errors.add({
        //     field: 'password',
        //     msg: 'Поле пароль должно содержать минимум 1 цифры'
        //   })
        // }
      }
    }
}
</script>
